export default __webpack_public_path__ + "static/media/v3.805aa6d2.webp";